module.exports = __webpack_public_path__ + "static/media/accessControlBuilding_43.395c479b.png";